/**
 * section-product-custom.js
 * Single source for all custom product-page behavior added on top of the
 * skeleton sections/product.liquid. Ported (vanilla JS, no jQuery — the new
 * theme does not load jQuery) from cottonink-current-theme:
 *   - assets/custom.js (lines 1-26 WA button, lines 348-374 soldout detection)
 *   - assets/product-measurements.js (size sort order, variant summary toggle)
 *   - assets/product-password.js (password gate)
 *
 * Size guide tabs use native <details>/<summary> in
 * sections/product.liquid + snippets/product-measurements.liquid, so no
 * Station Tabs port is needed for opening/closing the panel — only the
 * variant-select-inside-panel behavior is ported here.
 */
(function () {
  'use strict';

  // Single shared size-order source (previously duplicated between custom.js
  // and product-measurements.js in the current theme).
  var SIZE_ORDER = [
    'xs', 's', 'm', 's/m', 'l', 'xl', 'l/xl', 'xxl', 'xxxl', 'xxl/xxxl', 'xxxxl',
    '2xl', '3xl', '1-2 year', '1-2year', '3-4 year', '3-4year', '5-6 year',
    '5-6year', '7-8 year', '7-8year', '9- 10 year', '9-10 year', '9-10year',
    '11-12 year', '11-12year', '11-12 years'
  ];

  function normalizeSizeValue(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\s*\/\s*/g, '/')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function sizeRank(value) {
    var index = SIZE_ORDER.indexOf(normalizeSizeValue(value));
    return index === -1 ? SIZE_ORDER.length : index;
  }

  /* -------------------------------------------------------------------- */
  /* WhatsApp customer-service order button                                 */
  /* -------------------------------------------------------------------- */
  function initChatPdp() {
    var button = document.querySelector('[data-ci-wa-trigger]');
    if (!button) return;

    button.addEventListener('click', function (e) {
      e.preventDefault();

      var select = document.querySelector('select[name="id"]');
      var selectedOption = select ? select.options[select.selectedIndex] : null;
      var sizeValue = selectedOption ? selectedOption.getAttribute('data-value') : '';
      var productName = button.getAttribute('data-product') || '';

      var message = 'https://api.whatsapp.com/send?phone=6282125665259&text=Hi Min, saya cari product ' +
        productName + ' size ' + sizeValue + ' Apakah masih ada di channel lain? ';
      message = message.replace(/ /g, '%20');

      window.location.assign(message);
    });
  }

  /* -------------------------------------------------------------------- */
  /* Size swatch list (.ukuran / .variant-ukuran): sort + select sync      */
  /* -------------------------------------------------------------------- */
  function initSizeSwatches() {
    var wrapper = document.querySelector('.ukuran');
    if (!wrapper) return;

    var items = Array.prototype.slice.call(wrapper.querySelectorAll('.variant-ukuran'));
    if (!items.length) return;

    items
      .sort(function (a, b) {
        return sizeRank(a.getAttribute('data-value')) - sizeRank(b.getAttribute('data-value'));
      })
      .forEach(function (item) {
        wrapper.appendChild(item);
      });

    var select = document.querySelector('select[name="id"]');

    function selectSize(item) {
      if (!item) return;

      items.forEach(function (i) {
        i.classList.remove('is-selected');
      });
      item.classList.add('is-selected');

      var radio = item.querySelector('input[type="radio"]');
      if (radio) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (!select) return;
      var sizeValue = item.getAttribute('data-value');
      var options = Array.prototype.slice.call(select.options);
      var match = options.find(function (opt) {
        return opt.getAttribute('data-value') === sizeValue;
      });
      if (match) {
        select.value = match.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    items.forEach(function (item) {
      item.addEventListener('click', function () {
        selectSize(item);
      });
    });

    var checkedInput = wrapper.querySelector('input[type="radio"]:checked');
    var initialItem = checkedInput ? checkedInput.closest('.variant-ukuran') : null;
    if (!initialItem) {
      initialItem = items.find(function (item) {
        return !item.classList.contains('soldout-variant');
      }) || items[0];
    }
    if (initialItem) {
      items.forEach(function (i) {
        i.classList.remove('is-selected');
      });
      initialItem.classList.add('is-selected');
      var r = initialItem.querySelector('input[type="radio"]');
      if (r) r.checked = true;
    }
  }

  /* -------------------------------------------------------------------- */
  /* Product measurements: variant-select inside the size guide panel      */
  /* -------------------------------------------------------------------- */
  function initMeasurementsPanel() {
    var panel = document.querySelector('[data-measurements-panel]');
    if (!panel) return;

    var select = panel.querySelector('.size-guide-variant-select');
    var currentText = panel.querySelector('.size-guide-variant-current');
    var items = panel.querySelectorAll('.size-guide-item');
    var dropdown = panel.querySelector('[data-size-guide-dropdown]');
    var trigger = panel.querySelector('[data-size-guide-trigger]');
    var menu = panel.querySelector('.size-guide-variant-menu');
    if (!select || !items.length) return;

    function setMenuOpen(isOpen) {
      if (!dropdown || !trigger || !menu) return;
      dropdown.classList.toggle('is-open', isOpen);
      trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (isOpen) {
        menu.removeAttribute('hidden');
      } else {
        menu.setAttribute('hidden', '');
      }
    }

    function syncMenuSelection(variantId) {
      if (!menu) return;
      var id = String(variantId);
      menu.querySelectorAll('.size-guide-variant-menu__option').forEach(function (opt) {
        var selected = opt.getAttribute('data-variant-id') === id;
        opt.classList.toggle('is-selected', selected);
        opt.setAttribute('aria-selected', selected ? 'true' : 'false');
      });
    }

    function showVariant(variantId) {
      var id = String(variantId);
      items.forEach(function (item) {
        if (item.getAttribute('data-variant-id') === id) {
          item.removeAttribute('hidden');
        } else {
          item.setAttribute('hidden', '');
        }
      });
      select.value = id;
      if (currentText) {
        var selectedOption = select.options[select.selectedIndex];
        if (selectedOption) currentText.textContent = selectedOption.text;
      }
      syncMenuSelection(id);
    }

    if (dropdown && trigger && menu) {
      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        setMenuOpen(!dropdown.classList.contains('is-open'));
      });

      menu.addEventListener('click', function (e) {
        var opt = e.target.closest('.size-guide-variant-menu__option');
        if (!opt) return;
        showVariant(opt.getAttribute('data-variant-id'));
        setMenuOpen(false);
      });

      document.addEventListener('click', function (e) {
        if (!dropdown.contains(e.target)) setMenuOpen(false);
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') setMenuOpen(false);
      });
    }

    select.addEventListener('change', function () {
      showVariant(select.value);
    });
    showVariant(select.value);
  }

  /* Password gate handled by assets/product-password.js */

  function init() {
    initChatPdp();
    initSizeSwatches();
    initMeasurementsPanel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
